import {types as typesUser } from '../../components/CurrentUserLoader/actions.js'
import {types as typesErrors } from './actions.js'

const initialState = {
  notFound: false, //legacy
  userNotFound: false,
  internalError: false,
  redirect: false,
  code: null,
}

export default function reducer(state = initialState, action) {

  if(action.type === typesUser.CURRENT_USER_NOT_CONNECTED) {
    return {
      ...state,
      notFound: true, //legacy
      userNotFound: true,
    }
  } else if(action.type === typesErrors.REDIRECT_TO_NOT_FOUND) {
    return {
      ...state,
      redirect: true,
      code: 404,
    }
  } else if(action.type === typesErrors.REDIRECT_TO_ACCESS_DENIED) {
    return {
      ...state,
      redirect: true,
      code: 401,
    }
  } else if(action.type === typesErrors.CANCEL_REDIRECTS) {
    return {
      ...state,
      redirect: false,
    }
  }

  return state
}